import ProjectDescription from "./ProjectDescription";
import JournalDescription from "./JournalDescription";

export default {
  JournalDescription,
  ProjectDescription
};
